import script from "./ViewSongHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSongHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__